import { useEffect,  useRef } from "react";
import { Outlet } from 'react-router-dom';
import { Helmet, HelmetProvider  } from "react-helmet-async";
import Footer from "../components/Layout/Footer"
import Header from "../components/Layout/Header"
import SideNav from "../components/Layout/SideNav"

let scripts = [
  '/plugins/jquery/jquery.min.js',
  '/plugins/jquery-ui/jquery-ui.min.js',
  '/plugins/bootstrap/js/bootstrap.bundle.min.js',
  '/plugins/chart.js/Chart.min.js',
  '/plugins/sparklines/sparkline.js',
  '/plugins/jqvmap/jquery.vmap.min.js',
  '/plugins/jqvmap/maps/jquery.vmap.usa.js',
  '/plugins/jquery-knob/jquery.knob.min.js',
  '/plugins/moment/moment.min.js',
  '/plugins/daterangepicker/daterangepicker.js',
  '/plugins/tempusdominus-bootstrap-4/js/tempusdominus-bootstrap-4.min.js',
  '/plugins/summernote/summernote-bs4.min.js',
  'plugins/overlayScrollbars/js/jquery.overlayScrollbars.min.js',
  '/plugins/adminlte/adminlte.js'
];



export default function MainLayout({ children}) {
  const initialized = useRef(false);

  useEffect(() => {
    // 👇 add class to body element
    document.body.classList.add('layout-fixed');
    if (!initialized.current){
      initialized.current = true;
      scripts.forEach(function(url) {
        let script = document.createElement('script');
        script.src = url;
        script.async = false;
        document.body.appendChild(script);
      });
  }

  }, []);

  return (
    <HelmetProvider>
        <Helmet>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,700&display=fallback" />
          {/* Font Awesome */}
          <link rel="stylesheet" href="/plugins/fontawesome-free/css/all.min.css" />
          {/* Ionicons */}
          <link rel="stylesheet" href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          {/* Tempusdominus Bootstrap 4 */}
          <link rel="stylesheet" href="/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css" />
          {/* iCheck */}
          <link rel="stylesheet" href="/plugins/icheck-bootstrap/icheck-bootstrap.min.css" />
          {/* JQVMap */}
          <link rel="stylesheet" href="/plugins/jqvmap/jqvmap.min.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="/plugins/adminlte/adminlte.min.css" />
          {/* overlayScrollbars */}
          <link rel="stylesheet" href="/plugins/overlayScrollbars/css/OverlayScrollbars.min.css" />
          {/* Daterange picker */}
          <link rel="stylesheet" href="/plugins/daterangepicker/daterangepicker.css" />
          {/* summernote */}
          <link rel="stylesheet" href="/plugins/summernote/summernote-bs4.min.css" />
      </Helmet>
      <div className="preloader flex-column justify-content-center align-items-center">
          <img className="animation__shake" src="/dist/img/crmLogo.png" alt="CRM Expoproperty" height="60" width="60" />
       </div>
      <div className="wrapper">
          <Header />  
        
          <SideNav />
  
          <div className="content-wrapper">
          <Outlet />
        </div>

          <Footer />
        </div>
    </HelmetProvider>
  );
}
